import { createSlice } from "@reduxjs/toolkit";

export const authSlice = createSlice({
  name: "auth",
  initialState: {
    loggedIn: false,
  },
  reducers: {
    siteLogin: (state) => {
      state.loggedIn = true;
    },
    siteLogout: (state) => {
      state.loggedIn = false;
    },
  },
});

export const { siteLogin, siteLogout } = authSlice.actions;

export default authSlice.reducer;
